/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import React, { Component } from 'react';
import { dateFormat } from '../../../../utils/commonFunctions';

class PriceItPlusDescription extends Component {
  render() {
    const {
      data: {
        description, end_date, enrollment_status, is_ended
      }
    } = this.props;

    return (
      <div className="performance-details">
        {end_date && (
          <span className="text-bold">
            {is_ended ? 'Ended ' : 'Live until '}
            {dateFormat(end_date)}
          </span>
        )}
        <span className="text-bold float-right">{enrollment_status}</span>
        <div>
          {description}
        </div>
      </div>
    );
  }
}

export default PriceItPlusDescription;



// WEBPACK FOOTER //
// ./src/components/store-performance/user-performances/subcomponents/price-it-plus-description.jsx